import Vue from "vue"
import App from "./App.vue"
import router from "./router"
import store from "./store"
import vuetify from "./plugins/vuetify"
import i18n from "@/lang/lang"

Vue.config.productionTip = false

//component
import alert from "@/components/globals/Alert"
import confirmDialog from "@/components/dialogs/ConfirmDialog"
import CountrySeletor from "@/components/selectors/CountrySelector"
import CurrencySelector from "@/components/selectors/CurrencySelector"
import CustomerSelector from "@/components/selectors/CustomerSelector"
import VendorSelector from "@/components/selectors/VendorSelector"
import ProductSelector from "@/components/selectors/ProductSelector"
import TaxesSelector from "@/components/selectors/TaxesSelector"
import TimezoneSelector from "@/components/selectors/TimezoneSelector"
import BizTypeSelector from "@/components/selectors/BizTypeSelector"
import AccountSelector from "@/components/selectors/AccountSelector"
import AccountCategorySelector from "@/components/selectors/AccountCategorySelector"
import DateRangeSelector from "@/components/selectors/DateRangeSelector"

Vue.component("Alert", alert)
Vue.component("ConfirmDialog", confirmDialog)
// selectors
Vue.component("CountrySeletor", CountrySeletor)
Vue.component("CurrencySelector", CurrencySelector)
Vue.component("CustomerSelector", CustomerSelector)
Vue.component("VendorSelector", VendorSelector)

Vue.component("ProductSelector", ProductSelector)
Vue.component("TaxesSelector", TaxesSelector)
Vue.component("TimezoneSelector", TimezoneSelector)
Vue.component("BizTypeSelector", BizTypeSelector)
Vue.component("AccountSelector", AccountSelector)
Vue.component("AccountCategorySelector", AccountCategorySelector)
Vue.component("DateRangeSelector", DateRangeSelector)

router.beforeEach(async (to, from, next) => {
  let lang = to.params.lang
  lang = ["en", "tw"].includes(lang) ? lang : "tw"
  store.dispatch("account/updateLanguage", lang)
  i18n.locale = lang

  store.dispatch("global/closeAlert")
  document.title = getPageTitle(i18n, to.meta.title) || "2SUMUP"

  // next()
  const token = localStorage.getItem("token")
  if (token) {
    if (to.name == "Verify") {
      store.dispatch("auth/logout")
      store.dispatch("account/logout")
      store.dispatch("bizes/logout")
      next()
      return
    }
    // next()
    const { valid, isEmailVerified, name } = await varifyToken()
    if (!valid) {
      store.dispatch("auth/logout")
      store.dispatch("account/logout")
      store.dispatch("bizes/logout")
      if (to.meta.requireAuth) {
        next({ path: "/" + lang + "/login" })
      } else {
        next()
      }
    } else if (!isEmailVerified || name == null) {
      if (to.meta.requireAuth) {
        store.dispatch("auth/logout")
        store.dispatch("account/logout")
        store.dispatch("bizes/logout")
        next({ path: "/" + lang + "/login" })
      } else {
        next()
      }
    } else {
      if (to.meta.requireAuth) {
        next()
      } else {
        if (to.meta.back2Auth == false) {
          next()
        } else {
          // next()
          next({ path: "/" + lang + "/dashboard" })
        }
      }
    }
  } else {
    if (to.meta.requireAuth) {
      next({ path: "/" + lang + "/login" })
    } else {
      next()
    }
  }
})

function getPageTitle(i18n, key) {
  return i18n.t(key)
}

function varifyToken() {
  return store
    .dispatch("account/me")
    .then(function (result) {
      store.dispatch("account/updateUser", result.data)
      updateBizes()
      updateAccountings()
      store.dispatch("account/updateLastlyUsedBusinessId", result.data.lastlyUsedBusinessId)
      return Promise.resolve({
        valid: true,
        isEmailVerified: result.data.isEmailVerified,
        name: result.data.name
      })
    })
    .catch(function (error) {
      return Promise.resolve({ valid: false })
    })
}

function updateBizes() {
  store
    .dispatch("bizes/getBizes")
    // .dispatch("bizes/getBizes", { owned: true })
    .then(
      function (response) {
        store.dispatch("bizes/updateMyBizes", response.data)
      }.bind(this)
    )
    .catch(function (error) { }.bind(this))
}

function updateAccountings() {
  store
    .dispatch("accounting/getAccounts")
    .then(
      function (response) {
        store.dispatch("accounting/setAccounts", response.data.groups)
        // this.handleRawAccountsData(response.data.groups)
      }.bind(this)
    )
    .catch(function (error) { }.bind(this))
}

new Vue({
  router,
  store,
  vuetify,
  i18n,
  render: h => h(App)
}).$mount("#app")
